import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/qsbn.webp';
import screenshot_target from '../../../images/letterfunnel/pauldols.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Paul Dols"
      firstname="Paul"
      companyname="QSBN"
      competition="Wortell en Rapid Circle"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/pauldols.js